import { render, staticRenderFns } from "./TermsConditionsModal.vue?vue&type=template&id=3a5f11a3&scoped=true&"
import script from "./TermsConditionsModal.vue?vue&type=script&lang=js&"
export * from "./TermsConditionsModal.vue?vue&type=script&lang=js&"
import style0 from "./TermsConditionsModal.vue?vue&type=style&index=0&id=3a5f11a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5f11a3",
  null
  
)

export default component.exports